<template>
    <console-layout width="100%" max-width="1024">

        <console-title>
            <span>게시판 비방글 설정</span>
        </console-title>

        <console-body>
            <v-card :disabled="!$hasScope(['root', 'admin'])">
                <v-card-title class="subtitle-2">기본정보</v-card-title>
                <v-card-text>
                    <v-layout class="mx-n2">
                        <v-flex class="px-2"><v-text-field v-model="config.name" label="게시판명칭" persistent-placeholder hide-details /></v-flex>
                        <v-flex class="px-2"><v-text-field v-model="config.code" label="게시판코드" persistent-placeholder hide-details /></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4" :disabled="!$hasScope(['root', 'admin'])">
                <v-card-title class="subtitle-2">설정관리</v-card-title>
                <v-card-text>
                    <v-textarea v-model="config.swearWord" label="욕설·비방글 필터링" persistent-placeholder outlined hide-details rows="3" />
                </v-card-text>
            </v-card>
        </console-body>


        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-layout>
</template>

<script>
import api from "@/api";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";

export default {
    components: {
        NaverSmarteditor
    },
    data(){
        return {
            config: {
                _id: this.$route.params._config,

                code: null,
                name: null,
                swearWord: null
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.config._id){
                let { config } = await api.console.board.configs.get(this.config);
                this.config = config;
                console.log(this.config)
            }
        },
        async save(){
            this.config._id ? await api.console.board.configs.put(this.config) : await api.console.board.configs.post(this.config);
            alert("저장되었습니다");
            this.$router.go(-1);
        }
    }
}
</script>